import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { ClientActions } from "./actions";
import { ClientsService } from "@services/apis/clients/clients.service";
import { IClient } from "@interfaces/client.interface";

@Injectable()
export class ClientStoreEffects {
  constructor(private actions$: Actions, private apiService: ClientsService) { }

  createClient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientActions.createClient),
      switchMap(({ client }) =>
        this.apiService.create(client).pipe(
          map((client: IClient) =>
            ClientActions.createClientSuccess({ client })
          ),
          catchError((error: HttpErrorResponse) =>
            of(ClientActions.getErrors({ error }))
          )
        )
      )
    )
  );

  findAllClient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientActions.searchClients),
      switchMap(() => this.apiService.getAll().pipe(
        map(
            (clientList) => ClientActions.searchClientsSuccess({ clientList })),
            catchError((error: HttpErrorResponse) => of(ClientActions.getErrors({ error }))
        )
      ))
    )
  );


}
